import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Formik } from "formik";
import toast from "react-hot-toast";

import Loader from "../../components/loader";
import LoadingButton from "../../components/loadingButton";
import api from "../../services/api";

export default function View() {
  const [businessUnit, setBusinessUnit] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    (async () => {
      const { data } = await api.get(`/business_unit/${id}`);
      setBusinessUnit(data);
    })();
  }, []);

  if (!businessUnit) return <Loader />;

  return (
    <div>
      <div className="appContainer pt-24">
        <Formik
          initialValues={businessUnit}
          onSubmit={async (values) => {
            try {
              const { cash_position, cash_position_currency, cash_position_updated_at, ...payload } = values;
              const { data } = await api.put(`/business_unit/${businessUnit._id}`, payload);
              setBusinessUnit(data);
              toast.success("Updated!");
            } catch (e) {
              console.log(e);
              toast.error("Some Error!");
            }
          }}>
          {({ values, handleChange, handleSubmit, isSubmitting }) => (
            <React.Fragment>
              <div className="flex items-center gap-3 mb-6">
                {values.emoji && <span className="text-3xl">{values.emoji}</span>}
                {values.color && <span className="w-6 h-6 rounded-full inline-block border border-gray-200" style={{ backgroundColor: values.color }} />}
                <h1 className="text-2xl font-semibold text-[#212325]">{values.name}</h1>
              </div>

              <CashPositionCard
                amount={businessUnit.cash_position}
                currency={businessUnit.cash_position_currency}
                updatedAt={businessUnit.cash_position_updated_at}
              />

              <div className="flex items-center space-x-4">
                <div className="w-full md:w-64 mt-[10px] mb-2">
                  <div className="text-[14px] text-[#212325] font-medium">Name</div>
                  <input className="projectsInput text-[14px] font-normal text-[#212325] bg-[#F9FBFD] rounded-[10px]" name="name" value={values.name} onChange={handleChange} />
                </div>
                <div className="w-full md:w-64 mt-[10px] mb-2">
                  <div className="text-[14px] text-[#212325] font-medium">Key</div>
                  <input className="projectsInput text-[14px] font-normal text-[#212325] bg-[#F9FBFD] rounded-[10px]" name="key" value={values.key} onChange={handleChange} />
                </div>
                <div className="w-full md:w-32 mt-[10px] mb-2">
                  <div className="text-[14px] text-[#212325] font-medium">Emoji</div>
                  <input className="projectsInput text-[14px] font-normal text-[#212325] bg-[#F9FBFD] rounded-[10px]" name="emoji" value={values.emoji || ""} onChange={handleChange} />
                </div>
                <div className="w-full md:w-32 mt-[10px] mb-2">
                  <div className="text-[14px] text-[#212325] font-medium">Color</div>
                  <input type="color" className="h-[38px] w-full rounded-[10px] cursor-pointer" name="color" value={values.color || "#3b82f6"} onChange={handleChange} />
                </div>
              </div>

              <div className="w-full md:w-64 mt-[10px] mb-2">
                <div className="text-[14px] text-[#212325] font-medium">Status</div>
                <select
                  className="projectsInput text-[14px] font-normal text-[#212325] bg-[#F9FBFD] rounded-[10px]"
                  name="status"
                  value={values.status}
                  onChange={handleChange}>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>

              <div className="w-full mt-[10px] mb-2">
                <div className="text-[14px] text-[#212325] font-medium">Description</div>
                <textarea
                  className="w-full rounded-md border-[1px] bg-[#ffffff] disabled:bg-gray-100 border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 md:text-sm placeholder:text-gray-300 py-2 px-2"
                  rows="4"
                  name="description"
                  placeholder="Description de la business unit..."
                  value={values.description || ""}
                  onChange={handleChange}
                />
              </div>

              <div className="flex mt-2">
                <LoadingButton className="bg-[#0560FD] text-[14px] font-medium text-[#FFFFFF] py-[8px] px-[22px] rounded-[10px]" loading={isSubmitting} onClick={handleSubmit}>
                  Update
                </LoadingButton>
                <button className="ml-[10px] bg-[#F43F5E] text-[14px] font-medium text-[#FFFFFF] py-[8px] px-[22px] rounded-[10px]">Delete</button>
              </div>
            </React.Fragment>
          )}
        </Formik>
      </div>
    </div>
  );
}

function CashPositionCard({ amount, currency, updatedAt }) {
  if (amount === undefined || amount === null) {
    return (
      <div className="mb-6 rounded-[10px] border border-gray-200 bg-[#F9FBFD] px-4 py-3">
        <div className="text-[12px] uppercase tracking-wide text-gray-500">Cash position</div>
        <div className="text-[20px] font-semibold text-gray-400">—</div>
        <div className="text-[12px] text-gray-400">Not synced yet</div>
      </div>
    );
  }
  const formatted = `${Number(amount).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency || "EUR"}`;
  const updated = updatedAt ? new Date(updatedAt) : null;
  return (
    <div className="mb-6 rounded-[10px] border border-gray-200 bg-[#F9FBFD] px-4 py-3">
      <div className="text-[12px] uppercase tracking-wide text-gray-500">Cash position</div>
      <div className="text-[24px] font-semibold text-[#212325]">{formatted}</div>
      {updated && (
        <div className="text-[12px] text-gray-500">
          Last update: {updated.toLocaleString("fr-FR")}
        </div>
      )}
    </div>
  );
}
